export const SITE_URL = 'https://www.latitudefinancial.com.au';

export const TITLE_SUFFIX = ' - Latitude Financial Services';
